<template>
  <dialog class="dialog-modal-no-bg" id="fileDeleteModal" aria-labelledby="deleteConfirmationTitle">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <!-- Modal value holders -->
      <input id="courseId" type="hidden"/>
      <input id="testId" type="hidden"/>
      <input id="userId" type="hidden"/>
      <input id="deleteButton" type="hidden"/>
      <input id="itemId" type="hidden"/>
      <input id="messageType" type="hidden"/>
      <input id="deleteType" type="hidden"/>

      <div class="modal-content" style="color:black;">
        <div class="modal-header">
          <button type="button" class="close" style="font-size:2.3em" :aria-label="trans('lms.close')"
                  @click="modalBack()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h5 v-if="used_info_list.length > 0" class="modal-title" id="deleteConfirmationTitle">{{
              trans('lms.DeletingNotPossible')
            }}</h5>
          <h5 v-else class="modal-title" id="deleteConfirmationTitle">{{ trans('lms.deleteTitle') }}</h5>
        </div>
        <div class="modal-body">
          <div v-if="used_info_list.length > 0">
            <p> {{ trans('lms.ItemIsUsed') }} </p>
            <ul>
              <li v-for="item in used_info_list" :key="item.key">
                {{ item.model_type_frontend }} :
                <a v-if="item.link" :href="item.link">{{ item.model_name }}
                  <template v-if="item.client_name">({{ item.client_name }})</template>
                </a>
                <template v-else> {{ item.model_name }}</template>
                <ul v-if="item.meetings">
                  <li v-for="meetings in item.meetings" :key="meetings.key">
                    {{ meetings.model_type_frontend }} :
                    <a :href="meetings.link">{{ meetings.model_name }}</a>
                  </li>
                </ul>

              </li>
            </ul>
          </div>
          <div v-else>
            {{ trans('lms.deleteText') }}
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary neutral" @click="modalBack()">
            {{ trans('lms.Cancel') }}
          </button>
          <button v-if="used_info_list.length == 0" type="button" class="btn btn-primary positive"
                  @click="this.deleteMethod">{{ trans('lms.Yes') }}
          </button>
        </div>
      </div>
    </div>
  </dialog>
</template>
<script>
export default {
  props: {
    deleteMethod: {type: Function},
    used_info_list: {type: Array},
  },
  data() {
    return {};
  },
  methods: {
    modalBack: function modalBack() {
      this.$el.close();
    },
  }
};
</script>